var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6601 8.40574C16.6601 12.6097 12.0454 16.9879 10.4958 18.34C10.1992 18.5654 9.79093 18.5654 9.49437 18.34C7.94476 16.9879 3.33008 12.6097 3.33008 8.40574C3.33008 4.68572 6.3141 1.67004 9.99508 1.67004C13.6761 1.67004 16.6601 4.68572 16.6601 8.40574Z",
    stroke: "#D4841A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.32996C7.5 6.94924 8.61929 5.82996 10 5.82996C11.3807 5.82996 12.5 6.94924 12.5 8.32996C12.5 9.71067 11.3807 10.83 10 10.83C8.61929 10.83 7.5 9.71067 7.5 8.32996Z",
    stroke: "#D4841A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLoc);
export default __webpack_public_path__ + "static/media/yellow-loc.abaadecf84ccaa7c8516519c519bb67c.svg";
export { ForwardRef as ReactComponent };